import { IClothesShopItem } from '~/rage';

export interface IListItem extends IClothesShopItem {
	active: boolean;
	new?: boolean;
}

export const groupItems = (items: IClothesShopItem[]) =>
	items
		.filter((item) => !item.parentItemId)
		.map((item) => ({
			id: item.id,
			items: items.filter(
				(filtered) =>
					filtered.parentItemId === item.id || item.id === filtered.id,
			),
		}));
